import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { LaunchOfferBadge } from '../LaunchOffer';
import { CTAButton } from '../CTAButton';
import { LAUNCH_DEADLINE, plans } from '../../data/programa';
const summaries: Record<string, string> = {
  standard: '6 Tomos + 6 Bonos',
  elite: '6 Tomos + 6 Bonos + Intervención Crítica'
};
export function Pricing() {
  const [selectedId, setSelectedId] = useState('elite');
  const selected = plans.find(plan => plan.id === selectedId) ?? plans[1];
  return <section id="precio" className="relative overflow-hidden border-b border-line bg-carbon py-[60px] lg:py-[100px]" data-id="element-184" data-mp="3ui2r1folvaq5">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-[radial-gradient(50%_100%_at_50%_0%,rgba(255,159,28,0.12)_0%,rgba(17,24,39,0)_100%)]" aria-hidden="true" data-id="element-185" data-mp="3b8b6bp8s1p0" />
      <div className="relative mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-186" data-mp="252ut7nr5om9c">
        <SectionHeading eyebrow="Precio de lanzamiento" title={<>
              Elegí tu pack.{' '}
              <span className="text-gold" data-id="element-188" data-mp="16k9wzzd2htfg">Precio de lanzamiento.</span>
            </>} data-id="element-187" data-mp="1bagn63n89lzt" />

        <Reveal delay={0.04} className="mt-8 flex flex-col items-center gap-3" data-id="element-189" data-mp="11kx4oz3ffu5h">
          <LaunchOfferBadge data-id="element-190" data-mp="11iubk66z9kwj" />
          <p className="text-[14px] text-cool" data-id="element-191" data-mp="xjli72funp1i">
            Válido hasta el {LAUNCH_DEADLINE} — después sube $10.000 ARS.
          </p>
        </Reveal>

        <fieldset className="mx-auto mt-10 max-w-4xl text-left" data-id="element-192" data-mp="1u8t8enreymbr">
          <legend className="sr-only" data-id="element-193" data-mp="1pbkooiqmaa8e">Elegí tu pack</legend>
          <div className="grid gap-5 md:grid-cols-2" data-id="element-194" data-mp="1l8wdw5icet8s">
            {plans.map((plan, index) => {
            const isSelected = plan.id === selectedId;
            return <Reveal key={plan.id} delay={index * 0.06} className="h-full" data-id="element-195" data-mp="1g9bfbw734mwl" data-mpi={index}>
                  <label className={`relative flex h-full cursor-pointer flex-col rounded-2xl border bg-white/[0.04] p-7 backdrop-blur-[10px] transition-[border-color,box-shadow] duration-200 ease-smooth ${isSelected ? 'border-gold shadow-glow' : 'border-gold/20 hover:border-gold/50'}`} data-id="element-196" data-mp="9usl32nhrb5b">
                    <input type="radio" name="pack" value={plan.id} checked={isSelected} onChange={() => setSelectedId(plan.id)} className="sr-only" data-id="element-197" data-mp="bb6enznd4qbf" />

                    {plan.featured ? <span className="absolute -top-3 left-7 rounded-full bg-gold px-4 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-ink" data-id="element-198" data-mp="1cqn5vkfbf1e">
                        Recomendado
                      </span> : null}

                    <div className="flex items-start justify-between gap-4" data-id="element-199" data-mp="3ohyapbuuyvuo">
                      <h3 className="text-[22px] font-bold leading-tight tracking-tight text-ice" data-id="element-200" data-mp="39sk0k1jgkae8">
                        {plan.name}
                      </h3>
                      <span className={`mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${isSelected ? 'border-gold bg-gold text-ink' : 'border-cool/60 text-transparent'}`} aria-hidden="true" data-id="element-201" data-mp="3erwpqsxsxtjz">
                        <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-202" data-mp="35srsrr1w289x" />
                      </span>
                    </div>

                    <p className="mt-3 text-[13px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-203" data-mp="2h6lqbfjrrvb9">
                      {summaries[plan.id]}
                    </p>

                    <p className="mt-4 flex-1 text-[15px] leading-[1.6] text-cool" style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  width: "290px",
                  height: "50px"
                }} data-id="element-204" data-mp="2v3if7bgbv2pi">
                      <span className="text-ice" data-id="element-205" data-mp="303wqr3h50usa">Ideal para:</span>{' '}
                      {plan.idealFor}
                    </p>

                    <div className="mt-7 flex flex-wrap items-end gap-3 border-t border-line pt-6" data-id="element-206" data-mp="3evx5c4k4tfmq">
                      <span className="text-[38px] font-bold leading-none tracking-tight text-ice" data-id="element-207" data-mp="39wub7f5owttj">
                        {plan.price}
                      </span>
                      <span className="text-[12px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-208" data-mp="3iwqtmz1hkwg5">
                        ARS
                      </span>
                      <span className="ml-auto text-[16px] text-cool line-through" data-id="element-209" data-mp="1m539q5kjulr2">
                        {plan.originalPrice}
                      </span>
                    </div>
                  </label>
                </Reveal>;
          })}
          </div>
        </fieldset>

        <Reveal delay={0.1} className="mx-auto mt-10 max-w-md" data-id="element-210" data-mp="1uzrhc2dlkfj1">
          <CTAButton pulse data-id="element-211" data-mp="y8pfjtcnj2hd">{selected.cta}</CTAButton>
          <p className="mt-3 text-[12px] text-cool" data-id="element-212" data-mp="136h4qflwwahv">
            Pago seguro vía nuestra plataforma de checkout
          </p>
        </Reveal>
      </div>
    </section>;
}